import { Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { APP_VERSION } from '../../../environments/version';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [FontAwesomeModule, TranslateModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  public items = [
    {
      icon: faPhone,
      title: 'Phone:', // Not used in html
      text: '+1 (786) 719-7443',
    },
  ];
  public version: string = APP_VERSION;
}
